import { render, staticRenderFns } from "./RouteProductStatus.vue?vue&type=template&id=a83e3c92&scoped=true&"
import script from "./RouteProductStatus.vue?vue&type=script&lang=js&"
export * from "./RouteProductStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83e3c92",
  null
  
)

export default component.exports